// 푸시 알림 API. 대상 사용자는 서버가 JWT 에서 정한다
import axiosApi from './daonAxios';

const authOption = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('jToken')}` },
});

// ========================================================================
// 푸시 토큰 등록
// ========================================================================

export const savePushToken = async (pushTknVal) => {
    if (!pushTknVal) return false;

    const res = await axiosApi.post(
        '/notifications/token',
        { pushTknVal },
        { ...authOption(), noLoading: true },
    );
    return res?.data?.success === true;
};

// ========================================================================
// 알림함
// ========================================================================

// 목록 (최근 30일)
export const getNotificationList = async () => {
    const res = await axiosApi.get('/notifications', authOption());
    return res?.data?.result ?? [];
};

// 읽음 처리
export const markNotificationRead = async (id) => {
    const res = await axiosApi.post(`/notifications/${id}/read`, null, {
        ...authOption(),
        noLoading: true,
    });
    return res?.data?.success === true;
};
